// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"aa22bbf8","453":"8a461303","833":"0268efd4"}[chunkId] + ".chunk.js";
};